import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../store';
import { dispatchCusEvent } from '../../utils';
import { ENUM_CUS_EVENT } from '../../enums/enums';

export default function useGetBonuses(groupId) {
  const bonuses = useAppSelector((state) => state.user.bonus?.[groupId]) || [];
  const [alreadyRequest, setAlreadyRequest] = useState(false);

  useEffect(() => {
    const bonusLists = Object.values(bonuses)?.flat();
    if (!groupId) return;
    if (alreadyRequest) return;
    if (bonusLists?.length) return;
    dispatchCusEvent(ENUM_CUS_EVENT.getBonusList, { groupId });
    setAlreadyRequest(true);
  }, [bonuses, groupId]);

  return bonuses;
}
